import { useMemo } from 'react'
import { ASSETS_TYPES, assetsCollectionElement, IEcommerceVideoAsset, IFileAsset } from '../types.ts'
import { getAssetType } from '../utils/getAssetType.ts'

// Groups the flat asset collection by type for the tabbed assets modal and locates the
// opened asset inside its bucket: which tab it belongs to and its in-tab position.
export default function useAssetsModalData(assetsCollection: assetsCollectionElement[], currentIndex: number) {
  return useMemo(() => {
    const imagesAssets: assetsCollectionElement[] = []
    const videoAssets: IEcommerceVideoAsset[] = []
    const modelAssets: IFileAsset[] = []

    for (const asset of assetsCollection) {
      switch (getAssetType(asset)) {
        case ASSETS_TYPES.VIDEO:
          videoAssets.push(asset as IEcommerceVideoAsset)
          break
        case ASSETS_TYPES.IMAGE:
          imagesAssets.push(asset)
          break
        case ASSETS_TYPES.MODEL:
          modelAssets.push(asset as IFileAsset)
          break
      }
    }

    const selectedAsset = assetsCollection[currentIndex]
    const selectedAssetType = getAssetType(selectedAsset)
    const isVideo = ASSETS_TYPES.VIDEO === selectedAssetType
    const isModel = ASSETS_TYPES.MODEL === selectedAssetType
    const isImage = ASSETS_TYPES.IMAGE === selectedAssetType

    const separatedIndex = isVideo
      ? videoAssets.indexOf(selectedAsset as IEcommerceVideoAsset)
      : isImage
        ? imagesAssets.indexOf(selectedAsset)
        : 0

    const activeTab = isImage ? 0 : isVideo ? 1 : 2

    return {
      images: imagesAssets,
      videos: videoAssets,
      models: modelAssets,
      selectedAsset,
      selectedAssetType,
      isVideo,
      isImage,
      isModel,
      separatedIndex,
      activeTab,
      hasVideos: videoAssets.length > 0,
      hasImages: imagesAssets.length > 0,
      hasModels: modelAssets.length > 0
    }
  }, [assetsCollection, currentIndex])
}
